module.exports = __webpack_public_path__ + "static/media/home-category-4.21c713d1.png";